import React from 'react'
import MuiButton from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import { makeStyles } from '@material-ui/core/styles'
import MuiTooltip from '@material-ui/core/Tooltip'
import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles(({ palette, spacing, fontSize }) => ({
  tooltip: {
    backgroundColor: `rgba(0, 0, 0, 0.7)`,
    color: `white`,
    borderRadius: 4,
    padding: spacing(1.5),
    fontSize: fontSize[0],
  },
  tooltipIcon: {
    fill: palette.success.main,
    width: 30,
    height: 30,
  },
}))

export default function Button({ loading = false, children, tooltip = undefined, ...props }) {
  const classes = useStyles()
  if (tooltip && !props.disabled) {
    return (
      <MuiTooltip
        title={
          <Typography
            variant="body1"
            className={classes.tooltip}
            dangerouslySetInnerHTML={{ __html: tooltip }}
          />
        }
        placement="top"
      >
        <MuiButton {...props}>
          {loading ? <CircularProgress color="secondary" /> : children}
        </MuiButton>
      </MuiTooltip>
    )
  }
  return (
    <MuiButton {...props}>{loading ? <CircularProgress color="secondary" /> : children}</MuiButton>
  )
}
